import sanitizeHtml from "sanitize-html"

const allowedTags = [
  "a",
  "abbr",
  "blockquote",
  "br",
  "code",
  "del",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "i",
  "img",
  "input",
  "li",
  "ol",
  "p",
  "pre",
  "strong",
  "table",
  "tbody",
  "td",
  "th",
  "thead",
  "tr",
  "ul",
]

export function sanitizeRichHtml(html = ""): string {
  const normalizedHtml = html.replace(/(\s(?:href|target|rel|title))=`([^`]*)`/g, '$1="$2"')
  return sanitizeHtml(normalizedHtml, {
    allowedTags,
    allowedAttributes: {
      a: ["href", "target", "rel"],
      abbr: ["title"],
      code: ["class"],
      img: ["alt", "decoding", "height", "loading", "src", "title", "width"],
      input: ["checked", "disabled", "type"],
      td: ["align"],
      th: ["align"],
    },
    allowedSchemes: ["http", "https", "mailto"],
    allowedSchemesByTag: {
      img: ["http", "https"],
    },
    exclusiveFilter: (frame) => {
      if (frame.tag === "a" && !frame.attribs.href) return "excludeTag"
      if (frame.tag === "img" && isRetiredImageHost(frame.attribs.src)) return true
      return false
    },
    transformTags: {
      a: (_tagName, attribs) => ({
        tagName: "a",
        attribs: {
          ...attribs,
          ...(attribs.target === "_blank" ? { rel: "noopener noreferrer" } : {}),
        },
      }),
      img: (_tagName, attribs) => ({
        tagName: "img",
        attribs: {
          ...attribs,
          alt: attribs.alt ?? "",
          decoding: "async",
          loading: "lazy",
        },
      }),
      input: (_tagName, attribs) => ({
        tagName: "input",
        attribs: {
          ...attribs,
          disabled: "disabled",
          type: attribs.type === "checkbox" ? "checkbox" : "",
        },
      }),
    },
  })
}

function isRetiredImageHost(src: string | undefined): boolean {
  if (!src) return false
  try {
    return new URL(src).hostname === "cdn.sanity.io"
  } catch {
    return false
  }
}
